import { useI18n } from "../i18n/LanguageContext";

export function Footer() {
  const { t, lang } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-black/5 bg-[#FDFBF7]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-14 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2 font-black text-xl">
            <span className="inline-block h-8 w-8 rounded-2xl bg-[#4361EE] grid place-items-center text-white shadow-[0_4px_0_#2A3EB1]">
              <span className="text-lg">✦</span>
            </span>
            <span>{lang === "ar" ? "سباركل" : "Sparkl"}</span>
          </div>
          <p className="mt-3 text-black/60 max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div className="text-sm text-black/60 md:text-center">
          <p className="font-bold text-black">{t("footer.credit")}</p>
          <p className="mt-1">© {year} · {t("footer.rights")}</p>
        </div>
        <div className="text-sm text-black/60 md:text-end">
          <p>‘ilm · علم</p>
          <p className="mt-1">GCC · MENA</p>
        </div>
      </div>
    </footer>
  );
}
